import React from "react";
import { SimpleGrid } from "@mantine/core";
import { FormTemplate } from "../../types/formTemplates";
import { TemplateCard } from "./TemplateCard";

interface StandardTemplatesGridProps {
  templates: FormTemplate[];
  selectedId: string | null;
  onSelect: (template: FormTemplate) => void;
}

export const StandardTemplatesGrid: React.FC<StandardTemplatesGridProps> = ({
  templates,
  selectedId,
  onSelect,
}) => {
  return (
    <SimpleGrid cols={{ base: 1, md: 2 }} spacing="md">
      {templates.map((template) => (
        <TemplateCard
          key={template.id}
          template={template}
          selected={selectedId === template.id}
          disabled={Boolean(template.is_mock_placeholder)}
          onClick={() => onSelect(template)}
        />
      ))}
    </SimpleGrid>
  );
};
